import axios from "axios";
import { Message } from "element-ui";
import { getAesString, decryptAesString } from "@/utils/encryption";
import router from '@/router'
import { isPublicPage } from '@/utils/publicPages'
import Vue from "vue";
const st = new Vue

/**
 * 后端 msg 里出现这些字样，才算「没登录 / 登录失效」。
 * 必须收窄判断：code==1 这个分支里还混着「手机号错误」这类普通业务报错，
 * 如果一律按未登录处理，用户填错手机号也会被莫名踢到登录页。
 */
function isLoginMsg(msg) {
  const m = String(msg || "");
  return /未登录|请登录|请先登录|登录失效|重新登录|登录已过期|登录超时|已在其他地方登录/.test(m);
}

/**
 * 登录失效的统一处理：不弹任何提示，清登录态后直接去登录页。
 * 2026-09-20 改：原来是「顶部弹一条红色 message + 跳回首页」，
 * 用户看完提示还得自己找登录入口；现在改成静默跳转，
 * 并用 redirect 记住当前地址，登录成功会自动回到刚才那一页（见 store/index.js）。
 *
 * ⚠️ 一级页面例外（2026-09-20 补）：需求是「一级页面未登录也要能看」。
 *    如果这里无条件跳登录页，那么一级页面只要有一个接口返回「您未登录」，
 *    用户刚打开页面就被踢走 —— 跟需求直接冲突。
 *    （真实案例：会员福利页、会员权益页未登录调套餐接口就是 code=1「您未登录」，
 *     不排除的话，用户永远看不到打码后的套餐列表。）
 *    所以一级页面只**静默清登录态**，不跳、不弹，页面靠自己的兜底数据渲染；
 *    等用户点进二级页面时，再由路由守卫拦到登录页。
 */
function gotoLogin() {
  const cur = router.currentRoute ? router.currentRoute.path : "";
  const onPublicPage = isPublicPage(cur);

  // 已经在登录页就别再跳（多个请求同时失败时会连推好几次，产生重复导航）
  if (cur === "/logIn") return;

  localStorage.removeItem("token");
  localStorage.removeItem("name");
  localStorage.removeItem("dataList");

  if (onPublicPage) return; // 一级页面：到此为止，安静地待着

  const redirect = router.currentRoute ? router.currentRoute.fullPath : "/";
  router.push({ path: "/logIn", query: { redirect } });
}

// 1. 本地开发环境  .env.Elemet

// 2. 测试环境 

// 3. 导出多个应用实例

// 4.

const service = axios.create({
  // 公共接口--webpack中的全局变量process.env.BASE_API
  // 为了适应多个后台或者开发的时候的api地址和发布的时候的api地址不一样这种情况
  baseURL: process.env.VUE_APP_baseURL,
  // baseURL: "/mobile",
  // baseURL: 'http://localhost:8092',
  // 超时时间 单位是ms，这里设置了3s的超时时间
  timeout: 20 * 1000,
});


/** 请求拦截器 */
// service.interceptors.request.use(
//   (config) => {
//
//     //加密
//     let to = localStorage.getItem("token")
//     if (to) {
//       config.data.token = to
//       console.log(config.data, "这里是http请求拦截器中的data配置");
//       config.data = { data: getAesString(config.data) }
//     } else {
//       config.data = { data: getAesString(config.data) }
//     }
//     return config;
//   },
//   (error) => {
//     Promise.reject(error);
//   }
// );
service.interceptors.request.use(
    (config) => {
      //加密
      let to = localStorage.getItem("token")
      if (config.url !== "/index/upload") {
        if (to) {
          config.data.token = to
          config.data = { data: getAesString(config.data) }
        } else {
          config.data = { data: getAesString(config.data) }
        }
      } else {
        // 2026-09-20 修（发布图片全链路 Bug 的总根因）：
        // 原来 config.data = { data: config.data } 会把 FormData 塞进普通对象，
        // axios 随后把它 JSON 序列化 —— 文件本体当场丢失，上传从未成功过
        // （后台看不到图、发布内容没图、缩略图异常全是它引起的）。
        // APP 端的对应实现（IssueActivity.upPicture）就是裸 multipart：
        // 文件字段名 upload、不加密、不包 data、不带 token —— 这里保持完全一致。
        // 注意：上传接口的鉴权由后端 session/来源控制，实测不带 token 可正常上传。
        return config;
      }

      return config;
    },
    (error) => {
      Promise.reject(error);
    }
);


/** 响应拦截器 */
service.interceptors.response.use(
  (response) => {
    let stc
    //接收到响应数据并成功后的一些共有的处理，关闭loading等
    if(response.config.url=="/Qcc/enterpriseExport"){
      stc = response.data
    }else {
      stc = decryptAesString(response.data)
    }

    // 2026-09-20 改（未登录引导）：
    //   原来未登录时会在页面顶部弹一条红色 message（Element 的 $message 默认就是
    //   顶部居中 + error 红字），显示后端返回的「您未登录」，用户看完还得自己找登录入口。
    //   现在改成：判定为未登录就静默跳登录页，一句提示都不弹。
    //   code==3 是 Token 过期 / 异地登录，一律算登录失效；
    //   code==1 只在后端 msg 明确提到「登录」时才算，其余（手机号错误等）照旧红字提示。
    if (stc.code == 3 || (stc.code == 1 && isLoginMsg(stc.msg))) {
      gotoLogin();
    } else if (stc.code == 2 || stc.code == 1) {
      st.$message({
        type: 'error',
        message: stc.msg
      })
    }


    return stc;

  },
  (error) => {
    /* ****  接收到异常响应的处理开始  **** */
    let goto = false; // 是否被判定为「登录失效」——决定末尾要不要弹那句红字
    if (error && error.response) {
      // 1. 公共错误处理
      // 2. 根据响应码具体处理
      switch (error.response.status) {
        case 400:
          error.message = "错误请求";
          break;
        case 401:
          error.message = "未授权，请重新登录";
          goto = true;
          break;
        case 403:
          error.message = "拒绝访问";
          break;
        case 404:
          error.message = "请求错误,未找到该资源";
          st.$router.push('/404')
          // window.location.href = "/NotFound";
          break;
        case 405:
          error.message = "请求方法未允许";
          break;
        case 408:
          error.message = "请求超时";
          break;
        // 500/501/502/503/504：原来一律按「登录失效」处理（清登录态 + 跳首页 + 红字提示）。
        // 实测真实后端上「未登录访问鉴权接口」返回的就是 500，所以这里继续按登录失效处理，
        // 但改成静默跳登录页，不再弹提示。
        case 500:
        case 501:
        case 502:
        case 503:
        case 504:
          goto = true;
          break;
        case 505:
          error.message = "http版本不支持该请求";
          break;
        default:
          error.message = `连接错误${error.response.status}`;
      }
    } else {
      // 超时处理
      if (JSON.stringify(error).includes("timeout")) {
        Message.error("服务器响应超时，请刷新当前页");
      }
      Message.error("连接服务器失败");
      error.message = "网络超时";
      goto = true;
    }

    if (goto) {
      gotoLogin();
    } else {
      // 只有非「登录失效」的错误才提示 —— 登录失效已经直接跳登录页了，
      // 再弹一句红字等于让用户看完了还得自己找路。
      Message.error(error.message + '请求失败');
    }

    /* ****  处理结束  **** */
    // 如果不需要错误处理，以上的处理过程都可省略
    return Promise.resolve(error.response);
  }
);



export default service












